module.exports = __webpack_public_path__ + "img/Banner1.e25ffbd2.png";